import { Label } from '@/presentation/components/label'
import { cn } from '@/presentation/utils'
import type * as LabelPrimitive from '@radix-ui/react-label'
import * as React from 'react'
import { useFormField } from './field'
import { useGetError } from './useGetError'

export const FieldLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  const { id, path } = useFormField()
  const error = useGetError(path)

  return (
    <Label
      ref={ref}
      className={cn(error && 'text-destructive', className)}
      htmlFor={id}
      {...props}
    />
  )
})

FieldLabel.displayName = 'FieldLabel'
